import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const LATEST_ACTIVITY_SCHEMA = Object.freeze({
    NAME: '',
    CATEGORY: '',
    TIMESTAMP: null, // i2g-date-time (yyyy-mm-dd'T'hh:mm:ssZ)
    SOURCE: '',
    RELATED_ENTITY_ID: null, // ''
    NEWLY_FULLY_PAID: false,
  }),
  RECORD = generateSchema(LATEST_ACTIVITY_SCHEMA),
  KEYS: any = generateKeys(LATEST_ACTIVITY_SCHEMA);

export class LatestActivity extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get timestamp(): string {
    return this.get(KEYS.TIMESTAMP);
  }
}
